import React from 'react'
import {getAvatar} from '../util/Avatar'

const HourlyBigFish = ({hourlyBigFish,length_measurement_symbol,weight_measurement_symbol}) => {
  console.log('hourlyBigFish value calculated:::',hourlyBigFish);

  if(hourlyBigFish.length !=0 && hourlyBigFish[0].hasOwnProperty("fish_weight")){
    return (
      <>
      
      {
      
       hourlyBigFish && hourlyBigFish.length > 0 && hourlyBigFish.map(({display, fish_type, user_photo, angler_name, angler_state, angler_city, largest_fish, dateSubmitted,is_member}, index) => 
          <div className='big-fish-entry' key={`bfentry${index}`}>
            <div className='big-fish-header' key={`bfheader${index}`}>{dateSubmitted ? dateSubmitted  + ' - ' : '' } {display}  </div>
  
            <div className="big-fish-left" key={`bfleft${index}`}>
              <div className="ang-img-container left" key={`bfimg${index}`}>  
                {getAvatar(user_photo, angler_name, '', `bf-${angler_name}`)}
              </div>
              <div>
                {(is_member === "1" || is_member === 1 ) ? <img src="/leaderboard/X.png" alt="TourneyX" className="stats"/> : <span/>}
                <span className="angler-marker" key={`bfmarkername${index}`}>{angler_name}</span>
              </div>
              <div key={`bfcity${index}`}><small key={`bfsmall${index}`}>{angler_city ? `${angler_city},` : ''}{angler_state ? `${angler_state}` : ''}</small></div>
            </div>
            
            <div key={`bfright${index}`} className='right'>
              <div key={`bfscore${index}`} className="big-fish-score">{largest_fish} {weight_measurement_symbol}</div>
              <div key={`bffishtype${index}`} className="big-fish-type"><small>{fish_type}</small></div>
            </div>
            <div key={`clear${index}`} className='clear' />
          </div>
        )
      }
      </>
    )
  }else{
    return (
      <>
      
      {
      
       hourlyBigFish && hourlyBigFish.length > 0 && hourlyBigFish.map(({display, fish_type, user_photo, angler_name, angler_state, angler_city, largest_fish, dateSubmitted,is_member}, index) => 
          <div className='big-fish-entry' key={`bfentry${index}`}>
            <div className='big-fish-header' key={`bfheader${index}`}>{dateSubmitted ? dateSubmitted  + ' - ' : ''} {display} </div>
  
            <div className="big-fish-left" key={`bfleft${index}`}>
              <div className="ang-img-container left" key={`bfimg${index}`}>  
                {getAvatar(user_photo, angler_name, '', `bf-${angler_name}`)}
              </div>
              <div>
               {(is_member === "1" || is_member === 1 ) ? <img src="/leaderboard/X.png" alt="TourneyX" className="stats"/> : <span/>}
                <span className="angler-marker" key={`bfmarkername${index}`}>{angler_name}</span>
              </div>
              <div key={`bfcity${index}`}><small key={`bfsmall${index}`}>{angler_city ? `${angler_city},` : ''}{angler_state ? `${angler_state}` : ''}</small></div>
            </div>
            
            <div key={`bfright${index}`} className='right'>
              <div key={`bfscore${index}`} className="big-fish-score">{largest_fish}{length_measurement_symbol}</div>
              <div key={`bffishtype${index}`} className="big-fish-type"><small>{fish_type}</small></div>
            </div>
            <div key={`clear${index}`} className='clear' />
          </div>
        )
      }
      </>
    )
  }
 

}

export default HourlyBigFish